import { render, staticRenderFns } from "./lookData.vue?vue&type=template&id=73f92ea6&scoped=true&"
import script from "./lookData.vue?vue&type=script&lang=js&"
export * from "./lookData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f92ea6",
  null
  
)

export default component.exports